module.exports = __webpack_public_path__ + "static/media/T12_headboard Finishing_Fabric_DK Grey.3e591b0e.png";